<template>
  <div :class="['bg-white rounded-lg shadow border border-gray-300 p-4', wrapperClass]">
    <h2 class="text-lg font-semibold mb-3 text-gray-800">{{ title }}</h2>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    title: {
      type: String,
      required: true
    },
    wrapperClass: {
      type: String,
      default: '' // You can override this in the parent component
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/Card.vue